import React from 'react'
import styled from 'styled-components'
import { Box, P, Tile, Flex, H2 } from '@allied-solutions/affinity'

const StyledTile = styled(Tile)`
  border-radius: ${props => props.theme.radii[6]};

  & .tile-content {
    border-radius: ${props => props.theme.sizes[6]};
  }
`

export const DashboardMaintenanceTile = () => {
  return (
    <StyledTile p="7xl">
      <Flex gap="7xl" alignItems="center">
        <Flex.Col colWidth={[12, 4]}>
          <Box>
            <P typeStyle="bodyMedium" color="text.secondary" mb="0">
              <img
                src="/maintenance-illustration.svg"
                alt="Under Maintenance"
              />
            </P>
          </Box>
        </Flex.Col>
        <Flex.Col colWidth={[12, 7]}>
          <Box>
            <H2 typeStyle="labelMedium" color="text.secondary" mb="2">
              Oh shoot...
            </H2>
            <P typeStyle="titleMedium.bold" mb="2">
              We're under maintenance.
            </P>
            <P typeStyle="labelLarge.regular" color="text.secondary" mb="0">
              MyInsuranceInfo is currently undergoing maintenance. We should be
              back shortly. Thank you for your patience!
            </P>
          </Box>
        </Flex.Col>
      </Flex>
    </StyledTile>
  )
}
